import type { IconProps } from "./types";

export function ChevronsLeft({
  size = 24,
  color = "currentColor",
  ...props
}: IconProps) {
  const currentColor =
    color === "currentColor"
      ? color
      : color.includes("#")
      ? color
      : `var(--${color})`;
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        d="M6.2636 0.263592C6.61508 -0.0878565 7.18558 -0.0878718 7.53704 0.263592C7.88839 0.615066 7.88845 1.18559 7.53704 1.53703L2.17376 6.90031L7.53704 12.2636C7.88839 12.6151 7.88845 13.1856 7.53704 13.537C7.18561 13.8885 6.61509 13.8884 6.2636 13.537L0.263604 7.53703C-0.087868 7.18556 -0.087868 6.61506 0.263604 6.26359L6.2636 0.263592Z"
        fill={currentColor}
        transform="translate(4.1 5.1)"
      />
      <path
        d="M6.2636 0.263592C6.61508 -0.0878565 7.18558 -0.0878718 7.53704 0.263592C7.88839 0.615066 7.88845 1.18559 7.53704 1.53703L2.17376 6.90031L7.53704 12.2636C7.88839 12.6151 7.88845 13.1856 7.53704 13.537C7.18561 13.8885 6.61509 13.8884 6.2636 13.537L0.263604 7.53703C-0.087868 7.18556 -0.087868 6.61506 0.263604 6.26359L6.2636 0.263592Z"
        fill={currentColor}
        transform="translate(11.1 5.1)"
      />
    </svg>
  );
}
